var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRecurring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Appointment-expand",
    transform: "translate(-835.000000, -517.000000)",
    fill: "#646464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(225.000000, 422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(610.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-recurring",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C9.50710685,0 11.299397,0.738340371 12.558383,1.95414305 L14.4461538,0.5 L13.9076923,4.64615385 L9.76153846,4.10769231 L11.7550286,2.5711806 C10.6868265,1.59430236 9.18795981,1 7.5,1 C3.8992193,1 1,3.8992193 1,7.5 C1,11.1007807 3.8992193,14 7.5,14 C11.1007807,14 14,11.1007807 14,7.5 C14,7.22385763 14.2238576,7 14.5,7 C14.7761424,7 15,7.22385763 15,7.5 C15,11.6530655 11.6530655,15 7.5,15 C3.34693455,15 0,11.6530655 0,7.5 C0,3.34693455 3.34693455,0 7.5,0 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRecurring);
export default __webpack_public_path__ + "static/media/icRecurring.4f038e9becbf90fe1cdfea4fed9c9930.svg";
export { ForwardRef as ReactComponent };